import { inject } from '@angular/core';
import { RoleSaveRequest } from '@portal/models/roleSaveRequest';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { AGENT_TYPE } from '@portal/auth';
import { environment as courierEnvironment } from './courier/environment';
import { environment as merchantEnvironment } from './merchant/environment';
import { environment as operatorEnvironment } from './operator/environment';
import ProfileTypeEnum = RoleSaveRequest.ProfileTypeEnum;

const ApiMap = {
  [ProfileTypeEnum.LEGAL_SELLER]: merchantEnvironment.endpoints,
  [ProfileTypeEnum.OPERATOR]: operatorEnvironment.endpoints,
  [ProfileTypeEnum.COURIER]: courierEnvironment.endpoints,
};

export function getImagesEndpoint(agentType: ProfileTypeEnum): string {
  return ApiMap[agentType].images;
}

export function getApiEndpoint(agentType: ProfileTypeEnum): string {
  return ApiMap[agentType].api;
}

export function getBuyerEndpoint(agentType: ProfileTypeEnum): string {
  return ApiMap[agentType].buyer;
}

export const getApiEndpointByProfileType = () => ApiMap[inject(AGENT_TYPE)].images;
